import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { MarkdownWYSIWYGEditor } from '@/components/common/MarkdownWYSIWYGEditor';

export interface AgentTabProps {
  name: string;
  description: string;
  prompt: string;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onPromptChange: (prompt: string) => void;
}

export function AgentTab({
  name,
  description,
  prompt,
  onNameChange,
  onDescriptionChange,
  onPromptChange,
}: AgentTabProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="agent-name">Name</Label>
        <Input
          id="agent-name"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Enter agent name"
        />
      </div>

      <div>
        <Label htmlFor="agent-description">Description</Label>
        <Textarea
          id="agent-description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Enter agent description"
          className="min-h-[100px]"
        />
      </div>

      <div>
        <Label htmlFor="agent-prompt">Prompt</Label>
        <div className="mt-2">
          <MarkdownWYSIWYGEditor
            initialValue={prompt}
            onChange={onPromptChange}
            placeholder="Enter agent prompt (supports markdown)"
            height={300}
          />
        </div>
      </div>
    </div>
  );
}
